import type { UserSystemVersionDTO } from '../types/users.types';

export function systemVersionLabel(version?: Pick<UserSystemVersionDTO, 'os_version'> & { platform: string }): string {
  if (!version?.os_version) return '未上报';
  const platform = version.platform === 'ios' ? 'iOS' : version.platform === 'android' ? 'Android' : version.platform;
  return `${platform} ${version.os_version}`;
}
